'use strict';

module.exports = function () {

    
$(document).on('click', '.js-social-analytics-link, .js-social-analytics a', function (e) {
    e.preventDefault();

    var socialNetwork = $(this).data('id');
    var socialAction = '';
    var socialBaseLink = $(this).data('analytics');

    switch (socialNetwork) {
    case 'email':
        socialAction = 'mail';
        break;

    case 'pinterest':
        socialAction = 'pin';
        break;

    default:
        socialAction = 'share';
        break;
    }

    var socialTarget = socialBaseLink.substring((socialBaseLink.substring(8, socialBaseLink.length).indexOf('/') + 8), socialBaseLink.length);

    if($(this).parents('.js-general-overlay-wishlist').length) {
        // analytics
        dataLayer.push({
            'event': 'custom_event',
            'eventCategory': 'Wish List',
            'eventAction': 'share',
            'eventLabel': socialNetwork
        });
    } else {
        // analytics
        dataLayer.push({
            'event': 'social',
            'socialNetwork': socialNetwork,
            'socialAction': socialAction,
            'socialTarget': socialTarget
        });
    }
});

$(document).ready(function () {
    if ($('.js-social-share-lazyloading').length){

        const observer = new MutationObserver(() => {
            // first time cc-share-overlay will be opened, zxing plugin will be added to the img
            if (!$('.js-social-share-lazyloaded').length){
                var container = $('.js-social-share-lazyloading');
                var url = container.data('url');
                var target = container.children('img');
                target.attr("src", url);
                container.addClass('js-social-share-lazyloaded');
                container.removeClass('js-social-share-lazyloading');
            }
        });

        observer.observe(document.querySelector('.cc-share-overlay'), {
            attributes: true,
            attributeFilter: ['style']
        });

        observer.observe(document.querySelector('.cc-mobile-content-share'), {
            attributes: true,
            attributeFilter: ['style']
        });

        observer.observe(document.querySelector('.cc-share-content'), {
            attributes: true,
            attributeFilter: ['style']
        });
    }
});

};
